// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3g7td","topBottomGutter":"Layout_topBottomGutter__lKk6y"};